import { trackPromise } from 'react-promise-tracker';

import api from '../../../../utils/API';
import { AderenciaBigNumbersBody, AderenciaDetailsBody, AderenciaDetailsCountBody } from './types';

const PRICE_ADHERENCE_BASE_URL = `${process.env.REACT_APP_ISA_PRICE_ADHERENCE_ENGINE_URL}`; // isa-price-adherence-engine
const SETUP_ADHERENCE_URL = `${process.env.REACT_APP_ISA_SETUP_URL}/price-adherence`; // isa-setup-engine

export const getAderenciaPrecosDetailingFiltros = data => {
  return trackPromise(
    api({
      url: `${PRICE_ADHERENCE_BASE_URL}/filters`,
      method: 'POST',
      params: {
        campo: data?.campo,
        page: data?.page || 0,
        size: data?.size || 50,
      },
      data: {
        query: data?.query || '',
      },
      expectToken: true,
    }).then(resp => resp),
    'aderencia-filter',
  );
};

export const getAderenciaPrecosProductDetailingFiltros = data => {
  return trackPromise(
    api({
      url: `${PRICE_ADHERENCE_BASE_URL}/filters/PRODUTO`,
      method: 'POST',
      params: {
        page: data?.page || 0,
        size: data?.size || 50,
      },
      data: {
        query: data?.query || '',
      },
      expectToken: true,
    }).then(resp => resp),
    'aderencia-filter',
  );
};

export const getAderenciaPrecosFiltros = data => {
  return trackPromise(
    api({
      url: `${SETUP_ADHERENCE_URL}/filters/setup/${data?.campo}`,
      method: 'POST',
      params: {
        page: data?.page || 0,
        size: data?.size || 50,
      },
      data: {
        query: data?.query || '',
      },
      expectToken: true,
    }).then(resp => resp),
    'aderencia-filter',
  );
};

export const getAderenciaPrecosSavedFilterList = () => {
  return trackPromise(
    api({
      url: `${SETUP_ADHERENCE_URL}/filters/saved/all`,
      method: 'GET',
      params: {
        page: 0,
        size: 50,
      },
      expectToken: true,
    }).then(resp => resp),
    'aderencia-filter',
  );
};

export const getAderenciaPrecosSavedFilterSearch = (query: string) => {
  return trackPromise(
    api({
      url: `${SETUP_ADHERENCE_URL}/filters/saved/search`,
      method: 'GET',
      params: {
        query,
      },
      expectToken: true,
    }).then(resp => resp),
    'aderencia-filter',
  );
};

export const getAderenciaPrecosSavedFilterItem = (id: number) => {
  return trackPromise(
    api({
      url: `${SETUP_ADHERENCE_URL}/filters/saved`,
      method: 'GET',
      params: {
        idFiltroSalvo: id,
      },
      expectToken: true,
    }).then(resp => resp),
    'aderencia-filter',
  );
};

export const savingAderenciaFilters = data => {
  return trackPromise(
    api({
      url: `${SETUP_ADHERENCE_URL}/filters/saved`,
      method: 'POST',
      data,
      expectToken: true,
    }).then(resp => resp),
    'aderencia-filter',
  );
};

export const getAderenciaPreferences = () => {
  return trackPromise(
    api({
      url: `${SETUP_ADHERENCE_URL}/preferences`,
      method: 'GET',
      expectToken: true,
    }).then(resp => resp),
  );
};

export const saveAderenciaPreferences = data => {
  return trackPromise(
    api({
      url: `${SETUP_ADHERENCE_URL}/preferences`,
      method: 'POST',
      data,
      expectToken: true,
    }).then(resp => resp),
    'aderencia-preference-filter',
  );
};

export const getAderenciaProductsByRange = (data: AderenciaBigNumbersBody) => {
  return trackPromise(
    api({
      url: `${PRICE_ADHERENCE_BASE_URL}/ranges`,
      method: 'POST',
      data,
      expectToken: true,
    }).then(resp => resp),
    'aderencia-ranges',
  );
};

export const getAderenciaBigNumbers = (data: AderenciaBigNumbersBody) => {
  return trackPromise(
    api({
      url: `${PRICE_ADHERENCE_BASE_URL}/big-numbers`,
      method: 'POST',
      data,
      expectToken: true,
    }).then(resp => resp),
    'aderencia-big-numbers',
  );
};

export const getAderenciaDetails = (data: AderenciaDetailsBody) => {
  return trackPromise(
    api({
      url: `${PRICE_ADHERENCE_BASE_URL}/details`,
      method: 'POST',
      data,
      expectToken: true,
    }).then(resp => resp),
    'aderencia-details-download',
  );
};

export const aderenciaDetailsDownload = (format: 'CSV' | 'XLSX', data: AderenciaDetailsBody) =>
  trackPromise(
    api({
      url: `${PRICE_ADHERENCE_BASE_URL}/details/download`,
      method: 'POST',
      expectToken: true,
      params: { format },
      data: JSON.stringify(data),
      responseType: 'arraybuffer',
    })
      .then(res => res)
      .then(download => {
        if (download.status === 200) {
          const blob = new Blob([download.data]);
          const hiddenElement = document.createElement('a');
          hiddenElement.href = window.URL.createObjectURL(blob);
          hiddenElement.target = '_blank';
          hiddenElement.download = `detalhamento.${format === 'XLSX' ? 'xlsx' : 'csv'}`;
          hiddenElement.click();
        } else {
          return download;
        }
      }),
    'aderencia-details-download',
  );

export const getAderenciaDetailsCount = (data: AderenciaDetailsCountBody) =>
  trackPromise(
    api({
      url: `${PRICE_ADHERENCE_BASE_URL}/details/download/count`,
      method: 'POST',
      expectToken: true,
      data: JSON.stringify(data),
    }).then(res => res),
    'aderencia-details-download',
  );

export const getAderenciaSavedFilters = data => {
  return trackPromise(
    api({
      url: `${SETUP_ADHERENCE_URL}/filters/saved/all`,
      method: 'POST',
      params: {
        page: data?.page || 0,
        size: data?.size || 50,
      },
      expectToken: true,
    }).then(resp => resp),
    'aderencia-filter',
  );
};

export const getAderenciaHistory = data => {
  return trackPromise(
    api({
      url: `${PRICE_ADHERENCE_BASE_URL}/products/history`,
      method: 'POST',
      data,
      expectToken: true,
    }).then(resp => resp),
    'aderencia-history',
  );
};

export const getAderenciaStatus = () => {
  return trackPromise(
    api({
      url: `${PRICE_ADHERENCE_BASE_URL}/status`,
      method: 'GET',
      expectToken: true,
    }).then(resp => resp),
    'aderencia-entry-status',
  );
};
